/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Receiver_HintInputs */

const vi_carrier_form_receiver_hint = /** @type {(inputs: Carrier_Form_Receiver_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa ở đây sẽ lưu vào đơn hàng rồi mới gửi sang hãng.`)
};

/**

* @param {Carrier_Form_Receiver_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_receiver_hint = /** @type {((inputs?: Carrier_Form_Receiver_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Receiver_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_receiver_hint(inputs)
});